import axios from 'axios';

const api = apiUrl => ({
  exec: ({ method, data, url }) => {
    const reqConfig = {
      method,
      url: `${apiUrl}/${url}`,
      withCredentials: true,
      headers: {
        Pragma: 'no-cache',
      },
    };

    if (method.toLowerCase() === 'get') {
      reqConfig.params = data;
    } else {
      reqConfig.data = data;
    }

    return axios(reqConfig);
  },
});
export default api;


// WEBPACK FOOTER //
// ./src/api-services/ajaxApiNoAuthorize.js